import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotateScreenIcon } from '../icons/RotateScreenIcon';

export const RotateScreen:React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-rotate-screen full">
      <RotateScreenIcon />
      <Text size="H2-Bold">{t('setup.rotate')}</Text>
    </div>
  );
};
